<template>
    <div class="app-inner" id="AppAuth">
         <div class="public-btn-div flex align-cen" v-if="!$route.query.id">
      <div class="public-add" @click="addApp" >
        新增手动授权
      </div>
    </div>
    <div class="p-tit-c">
        <div class="businessList-filter">
            <div class="businessList-filter-list flex align-cen">
                  <div class="fl-le flex align-cen">
          <div class="label">企业名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入企业名称" v-model="search" clearable> </el-input>
          </div>
         </div>
            <div class="fl-rt flex align-cen">
          <div class="label">企业标识：</div>
          <div class="el-select1">
          <el-input placeholder="请输入企业ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
            </div>
             <div class="businessList-filter-list flex align-cen">
                 <div class="fl-le flex align-cen">
          <div class="label">授权课程名称：</div>
          <div class="el-select1">
          <el-input placeholder="请输入授权课程名称" v-model="search2" clearable> </el-input>
          </div>
         </div>
            <div class="fl-rt flex align-cen">
          <div class="label">授权课程ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入授权课程ID" v-model="search3" clearable> </el-input>
          </div>
         </div>
           <div class="fl-rt flex align-cen">
          <div class="label">授权课程账号：</div>
          <div class="el-select1">
          <el-input placeholder="请输入授权课程账号" v-model="search4" clearable> </el-input>
          </div>
         </div>
             </div>
             <div class="businessList-filter-list flex align-cen">
          <div class="label">权限类型：</div>
         <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio"
        >
          不限
        </div>
        <el-radio v-model="radio" label="1" @change="searchList">手动授权</el-radio>
        <el-radio v-model="radio" label="2" @change="searchList">用户购买</el-radio>
             </div>
              <div class="businessList-filter-list flex align-cen">
                      <div class="fl-le flex align-cen">
          <div class="label">企业分类：</div>
            <el-select
            v-model="value1"
            clearable
            placeholder="请选择"
            @change="classSelect"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
              </div>
                 <div class="businessList-filter-list flex align-cen">
                <div class="fl-le flex align-cen">
                    <div class="label">创建时间：</div>
                      <el-date-picker
                        v-model="value3"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions2"
                        @change="dataSuccess1"
                        >
                        </el-date-picker>
                </div>
              </div>
              <div class="businessList-filter-list flex align-cen">
                <div class="fl-le flex align-cen">
                    <div class="label">到期时间：</div>
                     <el-radio-group v-model="radio1" size="medium"  @change="selectList">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="1">30天内</el-radio-button>
                        <el-radio-button label="2" >自定义</el-radio-button>
                        </el-radio-group>
                </div>
              </div>
                <div class="businessList-filter-list flex align-cen" v-if="radio1 == 2">
                <div class="fl-le flex align-cen">
                    <div class="label">选择时间：</div>
                      <el-date-picker
                        v-model="value2"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions2"
                        @change="dataSuccess"
                        >
                        </el-date-picker>
                </div>
              </div>
                 <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="searchList">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
        </div>
    </div>
        <div class="businessList-container">
         <div class="businessList-container-table">
              <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"

        >
          <el-table-column label="企业ID" align="center" prop="businessId"
           width="150"
          >
         </el-table-column>
          <el-table-column label="企业名称" align="center" prop="businessName">
         </el-table-column>
          <el-table-column label="企业类型" align="center" prop="businessClassifyName">
         </el-table-column>
           <el-table-column label="授权课程名称" align="center" prop="courseName">
         </el-table-column>
            <el-table-column label="权限类型" align="center" >
                <template slot-scope="scope">
                    <span>
                        {{scope.row.type == 2 ? '用户购买' : '手动授权'}}
                    </span>
                </template>
         </el-table-column>
          <el-table-column label="授权账号数" align="center" prop="accountNum">
         </el-table-column>
         <el-table-column label="创建时间" align="center"
           width="220"
           >
            <template slot-scope="scope">
                <span>
                    {{scope.row.createTime || '-'}}
                </span>
            </template>
         </el-table-column>
           <el-table-column label="服务开始时间" align="center"
           width="220"
           >
            <template slot-scope="scope">
                <span>
                    {{scope.row.startTime || '无限制时间'}}
                </span>
            </template>
         </el-table-column>
         <el-table-column label="服务结束时间" align="center"
         width="220"
         >
            <template slot-scope="scope">
                <span>
                    {{scope.row.endTime || '无限制时间'}}
                </span>
            </template>
         </el-table-column>
         <el-table-column label="授权人" align="center" prop="createBy">
         </el-table-column>
           <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="150"
            >
            <template slot-scope="scope">
                <el-button
                type="text"
                size="small"
                @click="openDetai(scope.row)"
                >查看详情</el-button >
                 <el-button type="text" size="small"  style="color:red" @click="delet(scope.row)">删除</el-button>
            </template>
           </el-table-column>
        </el-table>
         <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
         </div>
        </div>
    </div>
</template>
<script>
import { getbusinesstypelist, getCourseAuthList,courseAuthfun} from "@/api/index/index"  //应用分类、授权列表、删除授权
export default {
    name:'AppAuth',
    data() {
        return {
         pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
          value3:'',
            createTimeStart:'',
            createTimeEnd:'',
            search:'',
            search1:'',
            search2:'',
            search3:'',
            search4:'',
            itemList:[],
            radio1:'',
            radio:'',
            radio2:'',
            value:'',
            totalNum:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount: 0,
            pageSizes:[10,20,30,40,50,100],
            list:[],
            value1:'',
            value2:'',
            expireStartTime:'',
            expireEndTime:'',
            options:[]
        }
    },
         activated(){
   this.search3 = this.$route.query.id || ''
    this.gethisInfo()
},
    created() {
         this.$nextTick(() =>{
            this.getthisType()
        })
    },
    methods: {
      // 删除应用授权
      delet(data){
       if(data.type == 2) return this.$util.Notifi('用户购买不可删除','error','fa-exclamation-circle');
           this.$confirm('删除后会导致用户无法使用本授权，确认删除吗？', '删除授权', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            courseAuthfun({
              id:data.id,
              },'delete')
                .then(res => {
                 this.$util.Notifi('删除成功','success','fa-check')
                   this.gethisInfo()
              })
              .catch(err => {
              })
        })
      },
        // 打开详情
        openDetai(data){
            this.$router.push({
            name: "courseAuthDetail",
            query:{
                id:data.id
            }
           })
        },
         // 企业分类筛选
        classSelect(){
            // if(value.length !=0){
            //     let index = value.length-1
            //     this.value = value[index]
            //     this.value1 = this.$refs["cascaderAddr"].getCheckedNodes()[0].label
            // }else{
            //    this.value1 = "" 
            // }
             this.currentPage = 1
             this.gethisInfo()
        },
            allradio(type){
            this[`radio${type}`] = ""
            this.currentPage = 1
            this.gethisInfo()
        },
        // 到期时间
        selectList(){
             this.currentPage = 1
            if(this.radio1 == 0){
            this.expireStartTime = ""
            this.expireEndTime = ""
            this.gethisInfo()
            } else if(this.radio1 == 1){
                this.expireStartTime = this.$util.timeStampTurnTime(this.$util.getDay(-30).t)
                this.expireEndTime = this.$util.timeStampTurnTime(this.$util.getDay(0).t)
                this.gethisInfo()
            }
        },
        // 搜索
        searchList(){
             this.currentPage = 1
            this.gethisInfo()
        },
        // 重置
        reset(){
             this.search = ""
            this.search1 = ""
            this.search2 = ""
            this.search3 = ""
            this.search4 = ""
            this.value = ""
            this.radio = ""
            this.radio1 = ""
            this.radio2 = ""
            this.value2 = ""
             this.expireStartTime = ""
            this.expireEndTime = ""
            this.value1=""
            this.currentPage = 1
            this.gethisInfo()
        },
          // 时间选择
        dataSuccess(){
            if(this.value2){
             this.expireStartTime = this.value2[0]
            this.expireEndTime = this.value2[1]
            }else{
             this.expireStartTime = ""
              this.expireEndTime = ""
            }
             this.currentPage = 1
             this.gethisInfo()
        },
         dataSuccess1(){
           if(this.value3){
             this.createTimeStart = this.value3[0]
            this.createTimeEnd = this.value3[1]
            }else{
             this.createTimeStart = ""
              this.createTimeEnd = ""
            }
             this.currentPage = 1
             this.gethisInfo()
        },
        // 新增授权
        addApp(){
            this.$router.push("/addCourseAuth")
        },
                            // 获取列表
        gethisInfo(){
            let params = {
                appId:this.search3,
                businessName:this.search,
                businessId:this.search1,
                appName:this.search2,
                createBy:this.search4,
                type:this.radio,
                businessClassifyName:this.value1,
                expireStartTime:this.expireStartTime,
                expireEndTime:this.expireEndTime,
                current: this.currentPage,
                size:this.PageSize,
                createTimeStart:this.createTimeStart,
                createTimeEnd:this.createTimeEnd
            }
            getCourseAuthList(params)
            .then(res => {
              this.list = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
            // 获取企业分类
        getthisType(){
             getbusinesstypelist({
             })
            .then(res => {
              this.options = res.data
            })
            .catch(err => {
            })
        },
             handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
    },
}
</script>
<style lang="scss" scoped>
#AppAuth{
      .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
  .businessList-container-table,.jiange{
    margin-top: 20px;
  }
}
</style>